import { type NativeStackNavigationOptions, Stack } from 'expo-router';
import { withUnistyles } from 'react-native-unistyles';
import Loading from '@/components/Custom/Loading';
import useEmailLinkSignIn from '@/hooks/useEmailLinkSignIn';
import useInitializeAuth from '@/hooks/useInitializeAuth';
import useAuthStore from '@/stores/useAuthStore';

const UnistylesStack = withUnistyles(
  Stack,
  (
    theme,
  ): {
    screenOptions: NativeStackNavigationOptions;
  } => ({
    screenOptions: {
      animation: 'fade',
      contentStyle: {
        backgroundColor: theme.colors.background,
      },
      headerShown: false,
    },
  }),
);

export default function AppLayoutRoute() {
  const status = useAuthStore((state) => state.status);
  useInitializeAuth();
  useEmailLinkSignIn();

  if (status === 'loading') {
    return <Loading />;
  }

  return (
    <UnistylesStack>
      <Stack.Protected guard={status === 'in'}>
        <Stack.Screen name="(private)" />
      </Stack.Protected>
      <Stack.Protected guard={status === 'out'}>
        <Stack.Screen name="(auth)" />
      </Stack.Protected>
      <Stack.Screen name="(invite)/organization/invite" />
      <Stack.Screen name="(invite)/team/invite" />
    </UnistylesStack>
  );
}
